import { Roles } from "./roles";
import { Credits } from "./credits";

export class User extends Credits {
  [key: string]: any;
  _id?: string = "";
  _rev?: string = "";
  name: string = "";
  firstName?: string = "";
  lastName?: string = "";
  userName: string = "";
  email: string = "";
  password: string = "";
  roles: string[] = [];
  jobTitle: string = "";
  businessArea: string = "";
  displayAsComponent: boolean = false;
  active: boolean = true;
  passwordExpireDate: number = 0;
  lastFivePasswords?: {
    derived_key: string;
    iterations: number;
    salt: string;
  }[];
  retypePassword?: string = "";
  oldPassword?: string = "";
  lastChangedPassword?: number;
  forcePasswordChangeOnFirstLogin?: boolean = false;
  passwordNeverExpire: boolean = false;
  salt?: any;
  iterations?: any;
  derived_key?: any;
  language?: string = "";
  projectNumber?: string = "";
  businessManager?: boolean = false;
}

export class ViewUser extends Credits {
  _id: string = "";
  _rev?: string = "";
  name: string = "";
  email: string = "";
  roles: string[] = [];
  jobTitle: string = "";
  businessArea: string = "";
  displayAsComponent: boolean = false;
  active: boolean = true;
  passwordExpireDate: number = 0;
  lastChangedPassword?: number;
  forcePasswordChangeOnFirstLogin?: boolean = false;
  passwordNeverExpire: boolean = false;
  language?: string;
  projectNumber?: string;
  businessManager?: boolean = false;
  firstName?: string = "";
  lastName?: string = "";
}

export class UserCompressed {
  id: string = "";
  name: string = "";
  email: string = "";
  roles: string[] = [];
  jobTitle: string = "";
  businessArea: string = "";
  projectNumber?: string = "";
  displayAsComponent: boolean = false;
  active: boolean = true;
  passwordExpireDate: number = 0;
  businessManager?: boolean = false;
}

export class UserOptions {
  name: string = "";
  id: string = "";
  email: string = "";
  roles: string[] = [];
  jobTitle: string = "";
  businessArea: string = "";
  projectNumber?: string = "";
  businessManager?: boolean = false;
}

export class ResetToken {
  token: string = "";
  type: string = "resetToken";
}

export class UserWithRoles {
  username: string = "";
  roles: Roles = {
    admin: false,
    guest: false,
    team: false,
    user: false,
    analyst: false,
    RMAdmin: false,
  };
  token: string = "";
  id: string = "";
}

export class UserData {
  id: string = "";
  name: string = "";
}

/**
 * Quickly convert from a regular User entity to a stripped down ViewUser entity
 * @param user User entity to be converted
 * @param customer Customer the user is requested for - for stripping down roles
 * @returns Stripped down ViewUser entity
 */
export function convertUserForView(user: User, customer: string): ViewUser {
  let currentUser = {
    _id: user.id,
    _rev: user.rev,
    name: user.name,
    userName: user.userName,
    email: user.email,
    roles: user.roles.filter((r) => r.split("-")[0] === customer),
    jobTitle: user.jobTitle,
    businessArea: user.businessArea,
    displayAsComponent: user.displayAsComponent,
    active: user.active,
    passwordExpireDate: user.passwordExpireDate,
    lastChangedPassword: user.lastChangedPassword,
    forcePasswordChangeOnFirstLogin: user.forcePasswordChangeOnFirstLogin,
    passwordNeverExpire: user.passwordNeverExpire,
    language: user.language != "" ? user.language : "en",
    projectNumber: user.projectNumber,
    businessManager: user.businessManager,
    firstName: user.firstName,
    lastName: user.lastName,
    create_user_id: user.createUserId,
    update_user_id: user.updateUserId,
    create_time: user.createTime,
    update_time: user.updateTime,
  } as ViewUser;
  return currentUser;
}
